import { NgClass, isPlatformBrowser } from '@angular/common';
import {
  Component,
  DOCUMENT,
  HostListener,
  Inject,
  inject,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { RouterLink, ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SecondarySideMenuI } from '../../../../shared/interfaces/secondary-side-menu.interface';
import { COURSE_SECTION_SIDE_MENU_ITEMS } from './constants/side-menu.constant';

@Component({
  selector: 'app-programs-reports-side-menu',
  imports: [TranslateModule, NgClass, RouterLink],
  templateUrl: './programs-reports-side-menu.component.html',
  styleUrl: './programs-reports-side-menu.component.scss',
})
export class ProgramsReportsSideMenuComponent {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformID: Object
  ) {}

  private router = inject(Router);
  public route = inject(ActivatedRoute);
  sideMenuItems = COURSE_SECTION_SIDE_MENU_ITEMS;
  isSideMenuOpen = signal<boolean>(false);

  ngOnInit(): void {
    this.initScreenType();
  }

  public getSideMenuItemIcon(sideMenuItem: SecondarySideMenuI) {
    return this.router.url.endsWith('/' + sideMenuItem.route(''))
      ? sideMenuItem.activeIcon
      : sideMenuItem.nonActiveIcon;
  }

  public isCurrentRouteActive(sideMenuItem: SecondarySideMenuI) {
    return this.router.url.endsWith('/' + sideMenuItem.route(''));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event & { target: { innerWidth: number } }) {
    this.isSideMenuOpen.update(
      () => event.target?.innerWidth <= 700 && event.target?.innerWidth >= 500
    );
  }

  initScreenType() {
    if (isPlatformBrowser(this.platformID)) {
      this.isSideMenuOpen.update(
        () =>
          this.document.defaultView!.innerWidth <= 700 &&
          this.document.defaultView!.innerWidth >= 500
      );
    }
  }
}
